/**
 * Truncates text to specified length and adds "..."
 * @param text - Text to truncate
 * @param maxLength - Maximum length (default: 20)
 * @returns Truncated text with "..."
 *
 * @example
 * truncateText('very long file name', 10)
 * // Returns: 'very long ...'
 */
export const truncateText = (text: string, maxLength: number = 20): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};
